<template>
    <div>
        <div class="content-header">
            <h3>查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item label="满减名称">
                    <el-input v-model="formInline.fullCutName" placeholder="满减名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="满减类型">
                    <el-select v-model="formInline.fullClass" clearable  placeholder="满减类型">
                        <el-option v-for="item in fullClassList"
                                   :key="item.value"
                                   :label="item.name"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="formInline.status" clearable  placeholder="状态">
                        <el-option v-for="item in statusListSearch"
                                   :key="item.value"
                                   :label="item.name"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="getList">查询</el-button>
                    <el-button type="success" size="mini" @click="handleUpdate({fullCutId:0})">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <!--<el-table-column prop="fullCutId" label="标志"></el-table-column>-->
                <el-table-column prop="fullCutName" label="名称"></el-table-column>
                <el-table-column label="满减">
                    <template slot-scope="scope">
                        <p>分类:{{convertFullClass(scope.row.fullClass)}}</p>
                        <p>类型:{{convertType(scope.row.type)}}</p>
                        <p>满减规则:{{convertType(scope.row.cutRule)}}</p>
                        <p>状态:{{convertStatus(scope.row.status)}}</p>
                        <p>满减描述:{{convertFullCut(scope.row.fullCutNumbers)}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="有效期" width="250">
                    <template slot-scope="scope">
                        <p>开始时间:{{scope.row.beginTime}}</p>
                        <p>结束时间:{{scope.row.endTime}}</p>
                    </template>
                </el-table-column>
                <!--<el-table-column prop="beginTime" label="开始日期"></el-table-column>-->
                <!--<el-table-column prop="endTime" label="结束日期"></el-table-column>-->
                <!--<el-table-column prop="type" :formatter="convertType" label="满减类型"></el-table-column>-->
                <!--<el-table-column prop="fullNumber" label="满" sortable></el-table-column>-->
                <!--<el-table-column prop="cutNumber" label="减" sortable></el-table-column>-->
                <!--<el-table-column prop="fullCutNumbers" label="满减" :formatter="convertFullCut"  width="200"></el-table-column>-->
                <!--<el-table-column prop="cutRule" :formatter="convertRule" label="满减规则" sortable></el-table-column>-->
                <!--<el-table-column prop="cutRuleName" label="规则名" sortable></el-table-column>-->
                <!--<el-table-column prop="inventory" label="库存数" sortable></el-table-column>-->
                <!--<el-table-column prop="limitCount" label="限购数" sortable></el-table-column>-->
                <!--<el-table-column prop="status" :formatter="convertStatus" label="状态" sortable></el-table-column>-->
                <el-table-column  label="叠加" >
                    <template slot-scope="scope">
                        <p>叠加促销:{{convertStatus1(scope.row.doublePromotion)}}</p>
                        <p>叠加赠品:{{convertStatus1(scope.row.doubleFreeGift)}}</p>
                        <p>叠加优惠劵:{{convertStatus1(scope.row.enableUseCoupon)}}</p>
                    </template>
                </el-table-column>

                <!--<el-table-column prop="doublePromotion" :formatter="convertStatus1" label="叠加促销"></el-table-column>-->
                <!--<el-table-column prop="doubleFreeGift" :formatter="convertStatus1" label="叠加赠品"></el-table-column>-->
                <!--<el-table-column prop="enableUseCoupon" :formatter="convertStatus1" label="叠加优惠劵"></el-table-column>-->
                <el-table-column prop="sysMessage" label="不可用原因">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sysMessage=='正常'" style="color: green">{{ scope.row.sysMessage }}</span>
                        <span v-else-if="scope.row.sysMessage!='正常' " style="color: red">{{ scope.row.sysMessage }}</span>
                    </template>

                </el-table-column>
                <el-table-column prop="activeNo" label="绑定码"></el-table-column>
                <el-table-column prop="createTime" label="创建日期"></el-table-column>
                <el-table-column label="操作"  width="160">
                    <template slot-scope="scope">
                        <el-button-group>
                        <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                        <el-button type="info" size="mini" @click="handlePreActive(scope.row)">预览</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="预览" :visible.sync="showPreviewDialog" v-if="showPreviewDialog" width="50%">
            <Preview :linkType="this.linkType" :activeType="this.activeType" :params="this.params"></Preview>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getFullCutList,
        saveOrUpdateFullCutList,
        getFullCutDetailList,
        saveMallFullcutDetail,
        deleteMallFullcutDetail,
        getActiveListL,
        getGroupListL,
        getProductListL,
        addFullCutAllColdProducts,
        addFullCutAllNomalProducts,
        delFullCutAllProducts
    } from '../../api/api';
    import Preview from "../../components/Preview";

    //定义组件
    export default {
        data() {
            return {
                linkType:0,
                activeType:null,
                params:{},
                showPreviewDialog:false,
                dataList: [],
                dataList1: [],
                getActiveList: [],
                getGroupList: [],
                getProductList: [],
                statusListSearch: [{value: -1, name: '全部'},{value: 1, name: '有效'}, {value: 0, name: '无效'}],
                statusList: [{value: 1, name: '有效'}, {value: 0, name: '无效'}],
                statusList1: [{value: 1, name: '是'}, {value: 0, name: '否'}],
                typeList: [{value: 1, name: '按数量'}, {value: 2, name: '按金额'}],
                productRuleList:[{value: 1, name: '赠送'}, {value: 2, name: '直减'}],
                ruleList: [{value: 1, name: '按最大金额金额减'}, {value: 2, name: '按最小金额减'}, {value: 3, name: '随机减'}, { value: 4, name: '指定商品' }],
                fullClassList:[{value:0,name:'满减活动'},{value:1,name:'全局满减'}],
                loading: true,
                loading1: true,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                formInline: {
                    fullCutName: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    status:-1,
                    fullClass:0
                },
                formInline1: {
                    fullcutId: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                form: {
                    fullCutId:"",
                    fullCutName:"",
                    beginTime:"",
                    endTime:"",
                    type:"",
                    fullNumber:"",
                    cutNumber:"",
                    cutRule:"",
                    cutRuleName:"",
                    limitCount:"",
                    status:"",
                    doublePromotion:"",
                    doubleFreeGift:"",
                    enableUseCoupon:"",
                    fullCutTitle:"",
                    productIdsForm:[],
                    productNames:"",
                    productRule:"",
                    activeNo:'',
                    fullClass:0,
                    fullCutNumbersForm:[]

                },
                fullCutNumbersStr:"",
                form1: {
                    fullCutId:'',
                    productId:[],
                    groupId:[],
                },
                amountDisabled:false,
                globalFullCutDisabled:false,
                typeDisabled:false
            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
            getActiveListL().then((res) => {
                this.getActiveList = res.data.value;
            })
            getGroupListL().then((res) => {
                this.getGroupList = res.data.value;
            });
            getProductListL().then((res) => {
                this.getProductList = res.data.value;
            })
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getFullCutList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            convertRule(cellValue) {
                if (cellValue == 1) {
                    return "按最大金额金额减";
                } else if (cellValue == 2) {
                    return "按最小金额减";
                } else if (cellValue == 3) {
                    return "按随机减";
                } else if (cellValue == 4) {
                    return "按指定商品";
                }else if (cellValue == 5) {
                    return "指定数量和金额减";
                }
            },
            convertType( cellValue) {
                if (cellValue == 1) {
                    return "按数量";
                } else if (cellValue == 2) {
                    return "按金额";
                }if (cellValue == 3) {
                    return "指定数量和金额";
                } else if (cellValue == 4) {
                    return "按数量折扣";
                }else {
                    return "按金额折扣";
                }
            },
            convertFullClass(cellValue) {
                if (cellValue == 0) {
                    return "满减活动";
                } else {
                    return "全局满减";
                }
            },
            convertStatus(cellValue) {
                if (cellValue == 1) {
                    return "有效";
                } else {
                    return "无效";
                }
            },
            convertStatus1(cellValue) {
                if (cellValue == 1) {
                    return "是";
                } else {
                    return "否";
                }
            },
            convertFullCut(cellValue){
                if(cellValue==null||cellValue==''){
                    return "";
                }
                var json=JSON.parse(cellValue);
                return this.convertFullCutStr(json);
            },
            handleUpdate(row) {
                this.$router.push({path:'/fullcut/detail/:id',name: 'fullcutDetail',params:{id:row.fullCutId}})
            },
            handleProductOrGroup(row) {
                this.dialogFormVisible1 = true;
                this.formInline1.fullcutId = row.fullCutId;
                this.form1.fullCutId = row.fullCutId;
                this.getFullCutDetailList();
            },
            getFullCutDetailList() {
                this.loading1 = true;
                getFullCutDetailList(this.formInline1).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline1.recordsTotal = res.data.value.total;
                        this.dataList1 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            typeChange(){
                if(this.form.type==2){//按金额
                    this.typeDisabled=true;
                    this.amountDisabled=true;
                    if(this.form.cutRule==4){
                        this.form.cutRule=1;
                    }
                    if(this.ruleList.length==4)
                        this.ruleList.splice(3,1);
                }else{
                    this.typeDisabled=false;
                    this.amountDisabled=false;
                    if(this.ruleList.length==3)
                        this.ruleList.push({ value: 4, name: '指定商品' });
                }
                this.cutRuleChange();
            },
            cutRuleChange(){
                if(this.form.cutRule==4){
                    this.amountDisabled=false;

                }else{
                    this.amountDisabled=true;

                }

            },
            convertFullCutStr(fullcut){
                if(fullcut==undefined){
                    fullcut=this.form.fullCutNumbersForm;
                }
                var str="";
                if(fullcut.length>0){
                    for(var i=0;i<fullcut.length;i++){
                        if(i==0){
                            str+="满"+fullcut[i].fullNumber+"减"+fullcut[i].cutNumber;
                        }else{
                            str+="；满"+fullcut[i].fullNumber+"减"+fullcut[i].cutNumber;
                        }
                    }
                }
                return str;
            },
            handlePreActive(row){
                this.activeType=11;
                this.params={bindCode:row.activeNo};
                console.log(row.activeNo);
                this.showPreviewDialog=true;
            },
        },
        components:{
            Preview
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/sales/fullcut.vue